import { Controller } from "stimulus"

// Sends the browser to the generated PDF once the loading page has painted.
// Used by the debt-free plan loading screen: the spinner stays on screen while
// the server renders the PDF, then the response replaces this page in place.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.hasUrlValue) {
      window.location.replace(this.urlValue)
    }
  }
}
